import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { colors } from 'design-system';
import React from 'react';

const useStyles = makeStyles({
  baseButton: {
    minWidth: 180,
    minHeight: 50,
    borderRadius: 40,
    fontWeight: 900,
    fontSize: 16,
    fontStyle: 'normal',
    textTransform: 'none',
    lineHeight: '24px',
  },
  defaultButton: {
    backgroundColor: colors.madison,
    color: colors.white,
    '&:hover': {
      backgroundColor: colors.onahau,
      color: colors.madison,
    },
    '&:disabled': {
      backgroundColor: colors.silver,
      color: colors.white,
    },
    '&:active': {
      backgroundColor: colors.madison,
      color: colors.bright_turquoise,
    },
  },
  outlinedButton: {
    backgroundColor: 'transparent',
    color: colors.madison,
    border: `2px solid ${colors.madison}`,
    '&:hover': {
      backgroundColor: colors.onahau,
      color: colors.madison,
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      border: `2px solid ${colors.silver}`,
      color: colors.silver,
    },
    '&:active': {
      background: 'transparent',
      color: colors.bright_turquoise,
      border: `2px solid ${colors.bright_turquoise}`,
    },
  },
  borderlessButton: {
    backgroundColor: 'transparent',
    color: colors.madison,
    border: 'none',
    '&:hover': {
      backgroundColor: colors.onahau,
      color: colors.madison,
    },
    '&:disabled': {
      backgroundColor: 'transparent',
      color: colors.silver,
    },
    '&:active': {
      backgroundColor: 'transparent',
      color: colors.bright_turquoise,
    },
  },
});

export type Props = {
  children?: React.ReactNode;
  disabled?: boolean;
  fullWidth?: boolean;
  type?: 'submit' | 'button' | 'reset';
  variant?: 'default' | 'outlined' | 'borderless';
  onClick?: () => void;
};

const DefaultButton = ({
  children,
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  variant = 'default',
}: Props): JSX.Element => {
  const classes = useStyles();
  let modifiedButtonClass: string;
  switch (variant) {
    case 'borderless':
      modifiedButtonClass = classes.borderlessButton;
      break;
    case 'outlined':
      modifiedButtonClass = classes.outlinedButton;
      break;
    default:
      modifiedButtonClass = classes.defaultButton;
  }

  return (
    <Button
      disabled={disabled}
      disableElevation
      className={clsx(classes.baseButton, modifiedButtonClass)}
      onClick={onClick}
      type={type}
      fullWidth={fullWidth}
    >
      {children}
    </Button>
  );
};

export default DefaultButton;
